import {WlRange} from "./range.component";
import { defineWebComponent } from "../webcomponents-utils";

export * from './range.component';
export default WlRange;

defineWebComponent('wl-range', WlRange);
